<template>
    <LayoutAutenticado>
        <div class="services-dashboard fade-in-up">
            <!-- Header -->
            <header class="page-header">
                <div>
                    <h1 class="page-title">Histórico de Serviços</h1>
                    <p class="page-subtitle">Acompanhe as Ordens de Serviço (OS), relatórios e retornos integrados na base.</p>
                </div>
            </header>
            <!-- Filter Bar V2 (restored original controls) -->
            <div class="filter-bar-v2">
                
              <div class="filter-group inputs-section">
                <div class="date-picker-wrapper">
                  <VueDatePicker v-model="dateRange" :range="true" placeholder="Filtrar por período..." auto-apply />
                </div>
                    
                <div class="search-wrapper">
                  <div class="input-wrapper" :class="{ 'valid-state': codigoInfo && codigoValido, 'invalid-state': codigoInfo && !codigoValido }">
                    <i class="bi bi-search icon text-primary"></i>
                    <input 
                      type="text" 
                      v-model="codigo" 
                      @input="validarCodigo" 
                      placeholder="QRA / Viatura / OS"
                      class="form-control" 
                    />
                  </div>
                  <span v-if="codigoInfo" class="search-feedback" :class="codigoValido ? 'text-success' : 'text-danger'">
                    <i class="bi" :class="codigoValido ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'"></i>
                    {{ codigoInfo }}
                  </span>
                </div>
              </div>

              <div class="filter-group dashboard-badges">
                <DashMensagemServicos :totalServices="amoutServices" :leftOverService="leftOverService" />
              </div>

              <div class="filter-group actions-section">
                <RoleGate minLevel="admin" :showWhenDenied="false" class="admin-actions">
                  <button class="circle-btn" @click="modelMessage" title="Mensagens Predefinidas">
                    <i class="bi bi-chat-square-text-fill"></i>
                  </button>
                  <button class="circle-btn" @click="modelEquipment" title="Configurar Modelos de Serviço">
                    <i class="bi bi-wrench-adjustable"></i>
                  </button>
                </RoleGate>

                <button @click="applyFilter" class="btn-primary v2-btn">
                  <i class="bi bi-funnel-fill"></i> Filtrar
                </button>
                <button @click="resetFilterAndReload" class="btn-secondary v2-btn">
                  <i class="bi bi-arrow-clockwise"></i> Recarregar
                </button>
                <button @click="showReportModal = true" class="btn-outline v2-btn">
                  <i class="bi bi-file-earmark-spreadsheet-fill text-success"></i> Exportar
                </button>
              </div>
            </div>

            <!-- Filtros Avançados (colapsável) -->
            <div class="mb-2 d-flex align-items-center gap-2">
              <button class="btn-secondary v2-btn" @click="showAdvanced = !showAdvanced">
                <i :class="showAdvanced ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
                <span style="margin-left:8px">Filtros Avançados</span>
              </button>
            </div>

            <transition name="slide-fade">
              <div v-show="showAdvanced" class="mb-3">
                <FilterToolbar
                  :filters="filters"
                  :uniqueQras="uniqueQras"
                  :uniqueViaturas="uniqueViaturas"
                  :uniqueModulos="uniqueModulos"
                  :uniquePerfis="uniquePerfis"
                  :uniqueObservacoes="uniqueObservacoes"
                  :clearFilters="clearFilters"
                />
              </div>
            </transition>

            <!-- Dados Planilha -->
            <div class="data-grid-container mt-4">
                <ServiceRow 
                  :services="filteredServices" 
                  :nameEquips="nameEquips" 
                  @update-service="onUpdate"
                  @delete-service="onDelete"
                />
            </div>

        </div>

        <!-- V2 Relatório Modal -->
        <Modal :isVisible="showReportModal" @close="showReportModal = false">
            <div class="modal-header-v2">
                <div>
                   <h3>Exportar Relatório</h3>
                   <span class="text-muted">Geração de planilha DRE por competência (XLSX).</span>
                </div>
                <button class="close-btn" @click="showReportModal = false"><i class="bi bi-x-lg"></i></button>
            </div>

            <div class="modal-body-v2 settings-form mt-4">
                <div class="form-group row-flex">
                    <div class="flex-1">
                        <label>Mês Competência</label>
                        <div class="select-wrapper default-border">
                            <select class="form-select" v-model="reportMonth" required>
                                <option disabled value="">Mês</option>
                                <option v-for="(month, index) in meses" :key="index" :value="index + 1">
                                    {{ month }}
                                </option>
                            </select>
                            <i class="bi bi-chevron-down select-icon"></i>
                        </div>
                    </div>

                    <div class="flex-1">
                        <label>Ano Base</label>
                        <div class="select-wrapper default-border">
                            <select class="form-select" v-model="reportYear" required>
                                <option disabled value="">Ano</option>
                                <option v-for="ano in anos" :key="ano" :value="ano">{{ ano }}</option>
                            </select>
                            <i class="bi bi-chevron-down select-icon"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer-v2 mt-4">
                <button class="btn-cancel" @click="showReportModal = false">Cancelar</button>
                <button class="btn-primary v2-btn" @click="requestReport">Gerar Arquivo</button>
            </div>
        </Modal>

        <!-- V2 Mensagens Modal -->
        <Modal :isVisible="showMessageModal" @close="showMessageModal = false">
            <div class="modal-header-v2">
                <div>
                   <h3>Mensagens de Retorno IA</h3>
                   <span class="text-muted">Parâmetros de validação de leitura por NLP (Inteligência Artificial).</span>
                </div>
                <button class="close-btn" @click="showMessageModal = false"><i class="bi bi-x-lg"></i></button>
            </div>

            <div class="modal-body-v2 settings-form mt-4">
                <div class="form-group">
                    <label>Tipo de Interação</label>
                    <div class="select-wrapper default-border">
                        <select class="form-select" v-model="tipoMensagem" required>
                            <option value="" disabled>Selecione um contexto</option>
                            <option value="CONCLUIDO">Concluído</option>
                            <option value="VISITA">Visita em Campo</option>
                        </select>
                        <i class="bi bi-chevron-down select-icon"></i>
                    </div>
                </div>

                <label class="mt-3">Strings Parametrizadas</label>
                <div class="model-entry" v-for="(mensagem, index) in mensagens" :key="'mensagem-' + index">
                    <div class="input-wrapper mb-2">
                        <i class="bi bi-justify-left icon text-primary"></i>
                        <input type="text" class="form-control" placeholder="Tag de leitura" v-model="mensagens[index]" />
                        
                        <!-- Mini Actions inside Wrapper -->
                        <div class="mini-actions ms-2">
                            <button class="action-ico text-success" v-if="index === mensagens.length - 1" @click="addEntryMensagem">
                                <i class="bi bi-plus-circle-fill"></i>
                            </button>
                            <button class="action-ico text-danger" v-if="mensagens.length > 1" @click="removeEntryMensagem(index)">
                                <i class="bi bi-dash-circle-fill"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer-v2 mt-4">
                <BotaoSalvar @click="saveMensagens" />
            </div>
        </Modal>

        <!-- V2 Equipamentos / Portal Aliases Modal -->
        <Modal :isVisible="showEquipmentModal" @close="showEquipmentModal = false">
            <div class="modal-header-v2">
                <div>
                   <h3>Configurações de Match do Equipamento</h3>
                   <span class="text-muted">Parâmetros dinâmicos de equivalência para rastreamento de OS.</span>
                </div>
                <button class="close-btn" @click="showEquipmentModal = false"><i class="bi bi-x-lg"></i></button>
            </div>

            <div class="modal-body-v2 settings-form mt-3 grid-split">
                
                <div class="form-group full-width">
                    <label>Perfil Pai de Equipamento</label>
                    <div class="select-wrapper default-border">
                        <select class="form-select" v-model="selectedEquip">
                            <option disabled value="">Equipamento Base</option>
                            <option v-for="equip in nameEquips" :key="equip" :value="equip">
                                {{ equip }}
                            </option>
                        </select>
                        <i class="bi bi-chevron-down select-icon"></i>
                    </div>
                </div>

                <div class="split-col">
                    <label>Padrões de Modelo</label>
                    <div class="model-entry" v-for="(modelo, index) in modelos" :key="'modelo-' + index">
                        <div class="input-wrapper mb-2">
                            <i class="bi bi-tag-fill icon text-primary"></i>
                            <input type="text" class="form-control" placeholder="Modelo serial..." v-model="modelos[index]" />
                            <div class="mini-actions ms-2">
                                <button class="action-ico text-success" v-if="index === modelos.length - 1" @click="addEntryModel"><i class="bi bi-plus-circle-fill"></i></button>
                                <button class="action-ico text-danger" v-if="modelos.length > 1" @click="removeEntryModel(index)"><i class="bi bi-dash-circle-fill"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="split-col">
                    <label>Apelidos no Portal</label>
                    <div class="model-entry" v-for="(nome, index) in nomesPortal" :key="'portal-' + index">
                        <div class="input-wrapper mb-2">
                            <i class="bi bi-cloud-check-fill icon text-success"></i>
                            <input type="text" class="form-control" placeholder="Label no portal..." v-model="nomesPortal[index]" />
                            <div class="mini-actions ms-2">
                                <button class="action-ico text-success" v-if="index === nomesPortal.length - 1" @click="addEntryNamePortal"><i class="bi bi-plus-circle-fill"></i></button>
                                <button class="action-ico text-danger" v-if="nomesPortal.length > 1" @click="removeEntryNamePortal(index)"><i class="bi bi-dash-circle-fill"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <div class="modal-footer-v2 mt-4">
                <BotaoSalvar @click="saveModels" />
            </div>
        </Modal>

        <!-- Toasts -->
        <div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1055;">
            <div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-header">
                    <i class="bi bi-info-circle-fill text-primary me-2"></i>
                    <strong class="me-auto">Atualização</strong>
                    <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                <div class="toast-body" id="toastBody">
                    Processando...
                </div>
            </div>
        </div>
    </LayoutAutenticado>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import LayoutAutenticado from '../components/layouts/LayoutAutenticado.vue';
import { showToast } from '@/eventBus.js';
import axios from '@/axios.js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Modal from '@/components/Modal.vue';
import BotaoSalvar from '@/components/ui/BotaoSalvar.vue';
import RoleGate from '../components/RoleGate.vue';
import ServiceRow from '../components/ServiceRow.vue';
import DashMensagemServicos from '../components/ServiceStatusDisplay.vue';
import FilterToolbar from '@/components/FilterToolbar.vue';
import { useServiceFilters } from '@/composables/useServiceFilters.js';

// Configuração do Day.js
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("America/Sao_Paulo");

// Data Context
const showReportModal = ref(false);
const showMessageModal = ref(false);
const showEquipmentModal = ref(false);
const reportMonth = ref(null);
const reportYear = ref(new Date().getFullYear());

const modelos = ref(['']);
const selectedEquip = ref('');
const mensagens = ref(['']);
const nomesPortal = ref(['']);
const tipoMensagem = ref('');
const meses = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];
const anos = ref([]);
const nameEquips = ref([]);
const amoutServices = ref(0);
const leftOverService = ref(0);
const services = ref([]);

const {
  filters,
  uniqueQras,
  uniqueViaturas,
  uniqueModulos,
  uniquePerfis,
  uniqueObservacoes,
  filteredServices,
  clearFilters,
} = useServiceFilters(services);

// Modals list manipulators
const addEntryModel = () => modelos.value.push('')
const removeEntryModel = (index) => modelos.value.splice(index, 1)
const addEntryNamePortal = () => nomesPortal.value.push('')
const removeEntryNamePortal = (index) => nomesPortal.value.splice(index, 1)
const addEntryMensagem = () => mensagens.value.push('')
const removeEntryMensagem = (index) => mensagens.value.splice(index, 1)

const showAdvanced = ref(false);

// Search filters
const dateRange = ref(null); 
const codigo = ref("");
const codigoInfo = ref("");
const codigoValido = ref(false);

function validarCodigo() {
    const value = codigo.value.trim();

    if (/^\d+$/.test(value)) {
        codigoInfo.value = "Busca por QRA";
        codigoValido.value = true;
    } else if (/^[A-Z]\d+$/.test(value)) {
        codigoInfo.value = "Busca por Viatura";
        codigoValido.value = true;
    } else if (/^\d+\/\d{2}$/.test(value)) {
        codigoInfo.value = "Busca por Ordem de Serviço";
        codigoValido.value = true;
    } else if (value === "") {
        codigoInfo.value = "";
        codigoValido.value = false;
    } else {
        codigoInfo.value = "Filtro Inválido";
        codigoValido.value = false;
    }
};

function applyFilter() {
  const companyId = localStorage.getItem("idCompany");

  const dataInicio = dateRange.value ? formatDate(dateRange.value[0]) : null;
  const dataFim = dateRange.value ? formatDate(dateRange.value[1] || dateRange.value[0]) : null;

  if (!dataInicio) {
    showToast("Selecione um range de data primeiro.");
    return;
  }

  axios.get(`/api/servicos/buscar/${companyId}`, {
    params: { dataInicio, dataFim, codigo: codigo.value },
  })
  .then((response) => {
    services.value = response.data.data;
    amoutServices.value = response.data.data.length;
    leftOverService.value = amoutServices.value;
    showToast("Filtro aplicado.");
  })
  .catch((error) => {
    showToast(error?.response?.data?.message || "Erro no filtro.");
  });
}

function formatDate(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};

function saveMensagens() {
    axios.post(`/api/report/message`, {
        mensagens: mensagens.value,
        tipo: tipoMensagem.value
    })
    .then((response) => {
        showToast(response.data.message || 'Dados armazenados na IA.');
        mensagens.value = ['']; 
        tipoMensagem.value = '';   
        showMessageModal.value = false;
    })
    .catch(error => {
        showToast(error?.response?.data?.message || "Erro");
    });
};

function saveModels() {
    axios.put(`/api/equipments/edit/models`, {
        models: modelos.value,
        portalName: nomesPortal.value,
        equip: selectedEquip.value
    }).then((response) => {
        showToast(response.data.message || 'Estrutura sincronizada com sucesso!');
        modelos.value = ['']; 
        nomesPortal.value = ['']; 
        selectedEquip.value = ''; 
        showEquipmentModal.value = false;
    }).catch(error => {
        showToast(error?.response?.data?.message || "Erro");
    });
};

function modelMessage() { showMessageModal.value = true; };
function modelEquipment() { showEquipmentModal.value = true; };

function resetFilterAndReload() {
    codigo.value = "";
    codigoInfo.value = "";
    dateRange.value = null;

    const companyId = localStorage.getItem("idCompany");
    const ano = new Date().getFullYear();

    axios.get(`/api/servicos/buscar/correct/${companyId}`, {
      params: { ano }
    }).then(response => {
      services.value = response.data.data.responseService;
      amoutServices.value = response.data.data.size;
      leftOverService.value = amoutServices.value;
      showToast("Dados recarregados do servidor.");
    }).catch(error => {
      showToast(error?.response?.data?.message || "Erro");
    });

    axios.get(`/api/equipments/all/${companyId}`)
        .then(response => {
            nameEquips.value = response.data.data.map(equip => equip.name);
        })
        .catch(() => {});
};

function requestReport() {
    if (!reportMonth.value || !reportYear.value) {
        showToast('Revise os parâmetros de mês e ano.');
        return;
    }

    const companyId = localStorage.getItem("idCompany");
    axios.get(`/api/reports/services/${companyId}`, {
        params: { mes: reportMonth.value, ano: reportYear.value },
        responseType: 'blob'
    }).then(async response => {
        const contentType = response.headers['content-type'];

        if (contentType && contentType.includes('application/json')) {
            const text = await response.data.text();
            const json = JSON.parse(text);
            showToast(json.message || "Violação de pacote do relatório");
            return;
        }

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `relatorio_servease_${reportMonth.value}_${reportYear.value}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        showToast('Download do XSLX em andamento!');
    }).catch(error => {
        showToast(error?.response?.data?.message || "Erro no micro-serviço de relatórios");
    });

    showReportModal.value = false;
};

// Lifecycle
onMounted(() => {
    const anoAtual = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
        anos.value.push(anoAtual - i);
    }
    const companyId = localStorage.getItem("idCompany");

    axios.get(`/api/servicos/buscar/correct/${companyId}`, {
      params: { ano: anoAtual }
    }).then(response => {
      services.value = response.data.data.responseService || [];
      leftOverService.value = amoutServices.value = response.data.data.size || services.value.length;
    }).catch(() => {});

    axios.get(`/api/equipments/all/${companyId}`)
        .then(response => {
            nameEquips.value = response.data.data.map(equip => equip.name);
        }).catch(() => {});
});

function refreshServicesList() {
  const companyId = localStorage.getItem("idCompany");
  if (!companyId) return;

  const dataInicio = dateRange.value ? formatDate(dateRange.value[0]) : null;
  const dataFim = dateRange.value ? formatDate(dateRange.value[1] || dateRange.value[0]) : null;

  if (dataInicio) {
    axios.get(`/api/servicos/buscar/${companyId}`, {
      params: { dataInicio, dataFim, codigo: codigo.value },
    })
    .then((response) => {
      services.value = response.data.data;
      amoutServices.value = response.data.data.length;
      leftOverService.value = amoutServices.value;
    })
    .catch((error) => {
      console.error("Erro ao atualizar os serviços:", error);
    });
  } else {
    const anoAtual = new Date().getFullYear();
    axios.get(`/api/servicos/buscar/correct/${companyId}`, {
      params: { ano: anoAtual }
    }).then(response => {
      services.value = response.data.data.responseService || [];
      leftOverService.value = amoutServices.value = response.data.data.size || services.value.length;
    }).catch((error) => {
      console.error("Erro ao recarregar os serviços padrão:", error);
    });
  }
}

function onUpdate() {
    if (leftOverService.value > 0) leftOverService.value--;
    refreshServicesList();
};

function onDelete({ type, index, retIndex }) {
  if (type === 'one') {
    services.value[index].oneService._hidden = true;
  } else if (services.value[index]?.oldServices?.[retIndex]) {
    services.value[index].oldServices[retIndex]._hidden = true;
  }
};


</script>

<style scoped>
/* Core Page Layout */
.services-dashboard {
  width: 100%;
}

.page-header {
  margin-bottom: 2rem;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #1E293B;
  margin-bottom: 0.25rem;
}

.page-subtitle {
  font-size: 0.95rem;
  color: #64748B;
  margin: 0;
}

/* Filter Bar V2 */
.filter-bar-v2 {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: center;
  justify-content: space-between;
  background: #FFF;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 4px 6px rgba(0,0,0,0.02);
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.inputs-section {
  flex: 1;
  min-width: 320px;
}

/* Base Wrapper Input for Services Search */
.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 0.4rem 1rem;
  transition: all 0.2s ease;
  flex: 1;
}

.input-wrapper:focus-within {
  border-color: #DF523A;
  background-color: #FFF;
  box-shadow: 0 0 0 3px rgba(223, 82, 58, 0.1);
}

.input-wrapper.valid-state {
  border-color: #10B981;
}

.input-wrapper.invalid-state {
  border-color: #EF4444;
  background-color: #FEF2F2;
}

.input-wrapper .icon {
  font-size: 1.15rem;
  margin-right: 0.75rem;
}

.form-control {
  flex: 1;
  background: transparent;
  border: none;
  font-family: inherit;
  font-size: 0.95rem;
  color: #1E293B;
  outline: none;
  min-width: 0; 
}
.form-control::placeholder { color: #CBD5E1; }

.search-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.search-feedback {
  font-size: 0.8rem;
  margin-top: 0.25rem;
  font-weight: 600;
  padding-left: 0.5rem;
}
.text-success { color: #10B981 !important; }
.text-danger  { color: #EF4444 !important; }
.text-primary { color: #3B82F6 !important; }

/* Filter Actions */
.actions-section {
  justify-content: flex-end;
}

.admin-actions {
  display: flex;
  gap: 0.75rem;
  margin-right: 1rem;
  border-right: 1px solid #E2E8F0;
  padding-right: 1.5rem;
}

.circle-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #F1F5F9;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  font-size: 1.25rem;
  transition: all 0.2s;
}

.circle-btn:hover {
  background-color: #DF523A;
  color: #FFF;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(223, 82, 58, 0.2);
}

.v2-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: #DF523A;
  color: #FFFFFF;
}
.btn-primary:hover {
  background-color: #C2412A;
}

.btn-secondary {
  background-color: #F1F5F9;
  color: #334155;
}
.btn-secondary:hover {
  background-color: #E2E8F0;
}

.btn-outline {
  background-color: transparent;
  color: #334155;
  border: 1px solid #CBD5E1;
}
.btn-outline:hover {
  border-color: #94A3B8;
  background-color: #F8FAFC;
}

/* Modals Override Settings */
.modal-header-v2 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 1rem;
  border-bottom: 1px dashed #E2E8F0;
}

.modal-header-v2 h3 {
  margin: 0 0 0.25rem 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: #0F172A;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.25rem;
  color: #94A3B8;
  cursor: pointer;
}
.close-btn:hover { color: #EF4444; }

.modal-footer-v2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  border-top: 1px dashed #E2E8F0;
  padding-top: 1.5rem;
}

.btn-cancel {
  background: transparent;
  border: none;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  padding: 0.5rem 1rem;
}
.btn-cancel:hover { color: #0F172A; }

.modal-body-v2 .grid-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.modal-body-v2 .full-width {
  grid-column: 1 / -1;
}

/* Select wrapper */
.select-wrapper {
  position: relative;
}
.select-wrapper.default-border {
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 0.5rem 1rem;
}
.select-wrapper.default-border:focus-within {
  border-color: #DF523A;
  background-color: #FFF;
}

.form-select {
  width: 100%;
  appearance: none;
  background: transparent;
  border: none;
  font-family: inherit;
  font-weight: 600;
  color: #334155;
  font-size: 0.9rem;
  outline: none;
  cursor: pointer;
  padding-right: 20px;
}

.select-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  pointer-events: none;
}

/* Modals layout elements */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.form-group label {
  font-weight: 600;
  color: #475569;
  font-size: 0.85rem;
}

.row-flex {
  display: flex;
  gap: 1rem;
}
.flex-1 { flex: 1; }

.mini-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.action-ico {
  background: none;
  border: none;
  font-size: 1.15rem;
  cursor: pointer;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.action-ico:hover { opacity: 1; }

/* Grid Core Config */
.data-grid-container {
  overflow: visible; /* Table inside handles overflow */
}

/* Animations */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.fade-in-up {
  animation: fadeInUp 0.5s ease forwards;
}

@media (max-width: 991.98px) {
  .actions-section { flex-wrap: wrap; justify-content: flex-start; }
  .grid-split { grid-template-columns: 1fr !important; }
}

/* Collapsible advanced filters animation */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.25s ease;
}
.slide-fade-enter-from, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
.slide-fade-enter-to, .slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>